<template>
	<NuxtImg
		v-if="srcBindings.src"
		v-bind="srcBindings"
		class="object-contain"
		:class="{'grayscale': isInStock(product) === false}"
		:alt="product.name || ''"
	/>
</template>

<script setup lang="ts">
	import {isInStock} from '~/utils';
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';

	type Props = {
		product: ProductDetail
		variant: 'detail' | 'icon' | 'thumbnail';
	};

	const props = defineProps<Props>();

	const src = computed(() => {
		switch (props.variant) {
			case 'detail':
				return props.product.imgDetail;
			case 'icon':
				return props.product.imgIcon;
			case 'thumbnail':
				return props.product.imgThumbnail;
			default: {
				const exhaustive: never = props.variant;
				throw new Error(`Unknown product image variant: ${exhaustive}`);
			}
		}
	});

	const placeholderSize = computed(() => {
		switch (props.variant) {
			case 'detail':
				return [602, 602];
			case 'icon':
				return [80, 80];
			case 'thumbnail':
				return [251, 251];
			default: {
				const exhaustive: never = props.variant;
				throw new Error(`Unknown product image variant: ${exhaustive}`);
			}
		}
	});

	const srcBindings = computed(() => (
		src.value
			? {src: src.value}
			: {
				src: '/images/product-placeholder.jpg',
				width: placeholderSize.value[0],
				height: placeholderSize.value[1],
			}
	));
</script>
